import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable  @typescript-eslint/no-explicit-any */
@Directive({
    selector: '[ngLet]',
    standalone: false,
})
export class LetDirective {
    private vcRef = inject(ViewContainerRef);
    private templateRef = inject<TemplateRef<any>>(TemplateRef);

    @Input() public set ngLet(context: any) {
        this.context.$implicit = this.context.ngLet = context;
        this.updateView();
    }

    public context: any = {};

    public updateView() {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }
}
